export default "__VITE_ASSET__98f74473__"